import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {LocationState} from '../../../slices/lightProfileSlice';

@customElement('visual-lightprofile-location')
export class VisualLightprofileLocation extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		width: 100%;
	  }
	  .container {
		display: flex;
		gap: 10px;
		flex-direction: row;
		align-items: end;
		height: 100%;
		width: 100%;

	  }
	  .overlay {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 0 var(--large-padding) var(--large-padding);
	  }
	  .defaultLocation {
			width: 100%;
			z-index: -1;
			position: absolute;
	}
	.defaultLocationMobile {
		display: none;
	}

		.baseInfo {
			position: absolute;
			bottom: var(--large-padding);
			left: var(--large-padding);
			right: var(--large-padding);
			z-index: 10;
		}
	  .title {
		font: var(--font-small-title);
		color: var(--color-white);
		margin-bottom: 0;
		border-bottom: 1px solid grey;
		padding-bottom: 20px;
	  }
	  .info {
		color: var(--color-grey3);
		font: var(--font-info-light);
		line-height: 30px;
		height: 100px;
		width: 500px;
	  }
		.moreInfo {
			color: var(--color-white);
			font: var(--font-summary-table);
			line-height: 30px;
			padding: 10px 15px;
			text-decoration: none;
			border: 1px solid var(--color-white);
			float: right;
			position: absolute;
			right: 0px;
			top: 140px;
		}
	  @media (max-width: 768px) {

		.overlay {
			bottom: 90px;
			position: relative;
			max-width: 100%;
			padding: var(--small-padding) var(--small-padding);
		}
		.info {
			font: var(--font-summary-paragraph);
			width: 100%;
			line-height: 25px;
		}
		.title {
			font: var(--font-mobile-title);
		}
		.moreInfo {
			position: initial;
			float: left;
		}
		.defaultLocationMobile {
			display: block;
			width: 100%;
			z-index: -1;
			position: absolute;
		}
		.defaultLocation {
			display: none;
		}
	 }
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.location = state.lightProfile.data.project.location;
		this.locationState = state.lightProfile.data.locationState;

	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
			<img class="defaultLocation" src="/line-assets/img/Ort_globe.png"/>
			<img class="defaultLocationMobile" src="/line-assets/img/Ort_globe_mobile.png"/>

				${choose(this.locationState, [
						[LocationState.valid, () => html`
							<div class="overlay">
								<div class="baseInfo">
									<h1 class="title">${this.location?.name ?? msg('Choose location of project')}</h1>
									<p class="info">
										${msg('The location is decisive for the configuration. Every location has different circumstances.')}<br>
										${when(this.location, () => html`
											(${msg('Latitude')}: ${this.location?.latitude}, ${msg('Longitude')}: ${this.location?.longitude})`)
										}
									</p>
								</div>
							</div>`
						],
						[LocationState.outOfRange, () => html`
							<div class="overlay">
								<div class="baseInfo">
									<h1 class="title">${msg('Location out of range')}</h1>
									<p class="info">${msg('For this location, please contact us so that we can provide you with a personal Circular Light Profile.')}</p>
									<a title="more-info" target="_blank" href="https://www.selux.com/${this.region}/${this.lang}/contacts/circular-light-profile-request" class="moreInfo">${msg('Contact form')}</a>
								</div>
							</div>`
						],
						[LocationState.notFound, () => html`
							<div class="overlay">
								<div class="baseInfo">
									<h1 class="title">${msg('Location not found')}</h1>
									<p class="info">
										${msg('We could not find the Location.')}</p>
								</div>
							</div>
						`]
					],
					() => html`
						<div class="overlay">
							<div class="baseInfo">
								<h1 class="title">${msg('Choose location of project')}</h1>
								<p class="info">
									${msg('The location is decisive for the configuration. Every location has different circumstances.')}<br>
								</p>
							</div>
						</div>
					`)
				}
			</div>
		`;
	}
}
